import React from 'react';
import { Box, Grid } from '@material-ui/core';
import Alert from '@mui/material/Alert';
import Typography from '../typography';
import ButtonComponent from '../button';
import { ReactComponent as ExclamationIcon } from '../../../assets/icons/icon-exclamation-orange.svg';

type AlertWarningProps = {
  onConfirmClick: () => void;
  onCancelClick: () => void; 
  isOpen: boolean;
};

const AlertWarning: React.FC<AlertWarningProps> = ({ onConfirmClick, onCancelClick, isOpen }) => {
  if (!isOpen) {
    return null;
  }
  return (
    <Box component="div">
      <Alert
        icon={<ExclamationIcon />}
        severity="warning"
        style={{
          width: 700,
          border: '1px solid #FF9F44',
          backgroundColor: '#FFEDCD',

         
        }}
      >
        <Typography fontWeight="700" color="secondary" mb={2}>
          Alteração de rota
        </Typography>
        <Typography color="secondary">
          Identificamos alterações na rota. Deseja otimizar o novo percurso?
        </Typography>
        <Typography fontWeight="700" color="secondary">
          Esta ação irá alterar a quilometragem estimada e o valor do frete.
        </Typography>
        <Grid container justifyContent="flex-start" style={{ marginTop: 15 }}>
          <ButtonComponent
            theme="primary"
            mr={3}
            style={{ width: 100, height: 25 }}
            onClick={onConfirmClick}
          >
            Sim
          </ButtonComponent>
          <ButtonComponent
            theme="outline-primary"
            style={{ width: 100, height: 25 }}
            onClick={onCancelClick}
          >
            Não
          </ButtonComponent>
        </Grid>
      </Alert>
    </Box>
  );
};

export default AlertWarning;
